// extracted by mini-css-extract-plugin
export default {"block":"DividerLine_block__PKeIu"};